// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Localidades_SalvaestadoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for salvaEstado() /localidades/salvaEstado
 *
 * Proxy to locations-service (Go microservice).
 * Returns the saved state record.
 */
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Localidades_SalvaestadoResponseDados {
id?: number
name?: string
code?: string
country_id?: number
}

export type Localidades_SalvaestadoResponse = ApiResponse<Localidades_SalvaestadoResponseDados>;

registerResponseContract('Localidades_SalvaestadoResponse', {
  id:         { type: 'number',  required: false },
  name:       { type: 'string',  required: false },
  code:       { type: 'string',  required: false },
  country_id: { type: 'number',  required: false },
})
